import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as jwt_decode from 'jwt-decode';
import { Observable } from 'rxjs/Observable';
import { LoginCommand } from '../../../commands/auth/login.command';
import { ButtonTriggerEvent } from '../../../common/components';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { AuthService } from '../../../common/services/auth.service';
import { ModalService } from '../../../common/services/modal.service';
import { TokenInfo } from '../../../models/auth/token.info';
import { LoginCredential } from './login.credential';

@Component({
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LoginComponent implements OnInit {
  public isLoginFailed = false;
  public accountStatus = null;
  public credential = new LoginCredential();
  public loginFormGroup: FormGroup;
  public supportLink = 'https://itidigital.freshdesk.com/support/tickets/new';
  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private router: Router,
    private modalService: ModalService
  ) {}

  public ngOnInit() {
    this.loginFormGroup = this.formBuilder.group({
      userName: [null, [Validators.required]],
      password: [null, [Validators.required]],
    });

    let wholeSpinner = document.getElementById('skeleton-mask');
    if (wholeSpinner) {
      wholeSpinner.style.display = 'none';
    }
  }

  public login(event: ButtonTriggerEvent) {
    this.isLoginFailed = false;
    this.accountStatus = null;

    this.authService
      .login(new LoginCommand(this.credential.userName, this.credential.password))
      .catch(() => {
        this.isLoginFailed = true;
        return Observable.throw(new Error('login failed'));
      })
      .finally(event.complete)
      .subscribe((token) => {
        let tokenInfo = jwt_decode<TokenInfo>(token);

        if (tokenInfo.status !== 'live') {
          this.accountStatus = 'Your account is disabled, please contact administrator.';
          return;
        }

        if (tokenInfo.isAdministrator) {
          if (tokenInfo.role === 'ig-admin') {
            this.router.navigateByUrl(getRouteUrl(routeConfigs.admin.accounts));
          }
          if (tokenInfo.role === 'ig-event-puller') {
            this.router.navigateByUrl(getRouteUrl(routeConfigs.admin));
          }
        } else {
          if (!window.location.href.includes('localhost')) {
            try {
              window['pendo'].initialize({
                account: {
                  id: tokenInfo.userName,
                  accountName: tokenInfo.userName,
                },
              });
            } catch (error) {
              console.error(error);
            }
          }

          this.router.navigateByUrl(
            getRouteUrl(routeConfigs.hub.eventCalendar, {
              hubName: tokenInfo.hubName || tokenInfo.userName,
            })
          );
        }
      });
  }

  openV3() {
    window.open('https://dxp.iti-digital.com/', '_blank');
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/auth/login/login.component.ts